(() => {
  const isTouch =
    window.matchMedia?.('(hover: none)').matches ||
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0;

  if (!isTouch) return;

  const SHOW_MS = 1600; // cuánto tiempo queda “abierta” la vista previa
  let openedCard = null;
  let closeTimer = null;

  const closePreview = (card) => {
    const media = card.querySelector('.card__media .media--hover-effect');
    media?.classList.remove('is-touch-hover');
    card.classList.remove('is-touch-preview');
    if (openedCard === card) openedCard = null;
  };

  const openPreview = (card) => {
    // cerrar cualquier otra abierta
    if (openedCard && openedCard !== card) closePreview(openedCard);

    const media = card.querySelector('.card__media .media--hover-effect');
    if (!media) return;

    media.classList.add('is-touch-hover');
    card.classList.add('is-touch-preview');
    openedCard = card;

    // autocierrar pasados X ms (opcional)
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      if (openedCard) closePreview(openedCard);
    }, SHOW_MS);
  };

  const hookCard = (card) => {
    if (card.dataset.touchInit) return; // evita duplicar listeners
    card.dataset.touchInit = '1';

    // En Dawn, el enlace principal suele tener esta clase:
    let link =
      card.querySelector('a.full-unstyled-link') ||
      card.querySelector('.card__heading a') ||
      card.querySelector('a[href*="/products/"]');

    const media = card.querySelector('.card__media .media--hover-effect');
    if (!media || !link) return;

    // Primer toque sobre el enlace: abre vista previa y evita navegar
    link.addEventListener(
      'click',
      (e) => {
        if (!card.classList.contains('is-touch-preview')) {
          e.preventDefault();
          openPreview(card);
        } else {
          // segundo toque: permitir la navegación
          // y cerrar cualquier previa abierta
          clearTimeout(closeTimer);
          closePreview(card);
        }
      },
      { passive: false }
    );

    // Tocar la imagen también abre la vista previa
    media.addEventListener(
      'touchstart',
      (e) => {
        if (!card.classList.contains('is-touch-preview')) {
          e.preventDefault();
          openPreview(card);
        }
      },
      { passive: false }
    );
  };

  const scan = (root = document) => {
    root.querySelectorAll('.card').forEach(hookCard);
  };

  // Escanea ahora…
  scan(document);

  // …y cuando la cuadrícula se re-renderice (paginación infinita, filtros, etc.)
  const mo = new MutationObserver((muts) => {
    for (const mut of muts) {
      mut.addedNodes?.forEach?.((n) => {
        if (n.nodeType === 1) scan(n);
      });
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Cerrar previa si se toca fuera
  document.addEventListener(
    'touchstart',
    (e) => {
      if (!openedCard) return;
      if (!openedCard.contains(e.target)) {
        closePreview(openedCard);
      }
    },
    { passive: true }
  );
})();
